import type { Page } from '../../types';
import { CORE_DEPARTMENTS } from '../core/coverSheet';

const secondmentsDepartments = [
  ...CORE_DEPARTMENTS,
  'AGO/GLD',
  'DLUHC',
  'FAST STREAM',
  'FSA',
  'NIO',
  'SCOT GOV',
  'UKEF',
  'UKSA/ONS',
  'WELSH GOV',
].sort();

const guidanceDescription = `<strong>Scope</strong>
This commission is focused on secondments between the Civil Service and external organisations (inc. Devolved Administrations, Crown Dependencies and Government of Ireland). Cross-Government loans are not in scope.
A secondment is the temporary assignment of an employee from one organisation to another. Civil servants can go on an outward secondment to an external organisation for an agreed period of time, while remaining employed by the Civil Service. An individual from outside the Civil Service can come into a Civil Service organisation on an inward secondment for an agreed period of time, while remaining an employee of the organisation from which they are seconded.
Loans are different to secondments. A loan is the temporary transfer of a civil servant from one Civil Service organisation to another Civil Service organisation.
<strong>Instructions</strong>
For this secondments data commission, please include all secondments which were active at some point between 1 October 2025 and 31 March 2026.
Please provide detailed data for these secondments (if you hold this) in the 'Inward Secondment Details' and 'Outward Secondment Details' sections.
If you only have partial information, please still input this in the 'Inward Secondment Details' and 'Outward Secondment Details' tabs.
This information will populate a summary table. If this is incorrect and you are aware of more inward and outward secondments that you don’t have full details for, you can edit this table. Please ensure this final table is accurate and aligns with your records.
<strong>Context</strong>
The data requested in this commission provides important insight into secondments activity. In conjunction with regular discussions with departments, professions and functions, the data enables us to build a picture of secondments activity across the Civil Service and provide up-to-date data to ministers when required.
<strong>Bulk upload</strong>
You can complete the inward and outward secondment pages of this form using Excel. Above each table, click the Excel download icon <img src="/images/excel-download.svg" alt="Excel download icon" width="20" height="20"> to download the Excel Template. Enter one secondment into the Excel template, use the dropdown lists where provided and keep the column headings unchanged. Save the file, then click the upload icon <img src="/images/excel-upload.svg" alt="Upload icon" width="20" height="20"> to upload the file and populate the form.
<strong>Note:</strong> Uploading a file will replace any existing details in that table.
<strong>Contact us</strong>
If you have any queries, please contact the Centre of Secondments Expertise by emailing secondmentexpertise@cabinetoffice.gov.uk.`;

const guidanceAndContact: Page[] = [
  {
    pageType: 'information',
    title: 'Commission Guidance',
    titleClassName: 'govuk-!-margin-bottom-4',
    name: 'commission-guidance',
    description: guidanceDescription,
    descriptionClassName: 'govuk-body-s',
  },
  {
    pageType: 'question',
    title: 'Department and contact email',
    name: 'department-and-contact-email',
    questions: [
      {
        questionType: 'select',
        title: 'Department',
        name: 'secondments-department',
        hintOption: 'Select a department',
        options: secondmentsDepartments,
        hideOptionalLabel: true,
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        title: 'Contact email',
        name: 'secondments-contact-email',
        hint: 'Provide your email address in case of any queries.',
        placeholder: 'name@domain.gov.uk',
        userEmail: true,
        hideOptionalLabel: true,
        rules: {
          required: true,
          email: true,
        },
      },
    ],
  },
];

export default guidanceAndContact;
